import { render, staticRenderFns } from "./businessArticle.vue?vue&type=template&id=605b1ae1"
import script from "./businessArticle.vue?vue&type=script&lang=js"
export * from "./businessArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports